module.exports = __webpack_public_path__ + "img/company_logo_whit_black_text.af73aff1.png";